/**
 * @fileoverview POST handler for the "/app_groups/:app_group_id/banner_priority" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdBannerPriorityCacheKeys } from "./constants";
import type {
  PostAppGroupsAppGroupIdBannerPriorityProps,
  PostAppGroupsAppGroupIdBannerPriorityResult,
} from "./types";

export const postAppGroupsAppGroupIdBannerPriority = reactQueryMutationAdapter(
  appGroupsAppGroupIdBannerPriorityCacheKeys,
  ({
    placementId,
    campaignIdsByPriorityBucket,
    requestedItemIds,
    appGroupId,
    pinnedItemId,
  }: PostAppGroupsAppGroupIdBannerPriorityProps): Promise<PostAppGroupsAppGroupIdBannerPriorityResult> => {
    return fetch(
      `/app_groups/${appGroupId}/banner_priority`,
      "POST",
      {
        placement_id: placementId,
        items_with_banners_ids: campaignIdsByPriorityBucket,
        requested_item_ids: requestedItemIds,
        pinned_item_id: pinnedItemId,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
